import React from 'react';
import Button from 'common/components/Button';
import propTypes from 'prop-types';

const StickyShoppingBanner = ({ title, price, displayText, href }) => (
  <div class="StickyShoppingBanner">
    <div class="content-wrapper">
      <div className="row">
        <div className="col-xs-6 StickyShoppingBanner__content">
          <h4>{title}</h4>
          <p className="heading--legend">{price}</p>
        </div>
        <div className="col-xs-6 StickyShoppingBanner__content--cta">
          <Button
            className="button-sticky--mobile button--full-width-mobile"
            element="a"
            href={href}
          >
            {displayText}
          </Button>
        </div>
      </div>
    </div>
  </div>
);

StickyShoppingBanner.propTypes = {
  title: propTypes.string.isRequired,
  price: propTypes.string.isRequired,
  displayText: propTypes.string.isRequired,
  href: propTypes.string.isRequired,
};

export default StickyShoppingBanner;
